export default __webpack_public_path__ + "6bf5cf6071710d129ffaadb50d2b0874.png";